<template>
  <div v-show="canShow() || isEditable">
    <v-toolbar
      :color="getColor"
      :dark="canShow()"
      dense
      v-on="isClickDisabled() ? {} : { click: onClickToggleChildren }"
    >
      <v-btn
        v-if="!isEditable && showArrowIcon"
        icon
        v-on="isClickDisabled() ? {} : { 'click.stop': onClickToggleChildren }"
      >
        <v-icon
          large
          color="white"
        >
          {{ iconArrow }}
        </v-icon>
      </v-btn>
      <v-row
        align="center"
        justify="center"
        :class="!showArrowIcon ? 'extra-padding' : ''"
      >
        <v-toolbar-title class="summary">
          {{ title }}
        </v-toolbar-title>
      </v-row>
      <v-btn
        v-if="isEditable && !isWorkOrderTemplate"
        icon
        @click="onClickToggleEditable"
      >
        <v-icon>
          {{ iconEye }}
        </v-icon>
      </v-btn>

      <v-btn
        v-if="showEye && isWorkOrderTemplate"
        icon
        @click.stop="onClickChangeState"
      >
        <v-icon color="white">
          {{ showCheckbox }}
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-card
      v-show="!isEditable && canShowChildren"
      class="border pa-4"
    >
      <v-container>
        <slot />
      </v-container>
    </v-card>
  </div>
</template>

<script>

export default {
    props: {
        isEditable: {
            type: Boolean,
            default: false,
        },
        visible: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '',
        },
        showArrowIcon: {
            type: Boolean,
            default: true,
        },
        showChildren: {
            type: Boolean,
            default: true,
        },
        isWorkOrderTemplate: {
            type: Boolean,
            default: false,
        },
        showEye: {
            type: Boolean,
            default: true,
        },
        hasChildren: {
            type: Boolean,
            default: false,
        },
        headerColor: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isVisible: this.visible === true,
            canShowChildren: this.showChildren,
        };
    },
    computed: {
        iconArrow() {
            return this.canShowChildren ? 'mdi-menu-down' : 'mdi-menu-right';
        },

        showCheckbox() {
            if (this.hasChildren && this.showEye) {
                return !this.visible ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-outline';
            }
            return this.visible ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-outline';
        },

        iconEye() {
            return this.isVisible ? 'mdi-eye' : 'mdi-eye-off';
        },
        getColor() {
            let currentCollor;
            if (this.headerColor) {
                currentCollor = this.headerColor;
            } else {
                currentCollor = this.canShow() ? 'primary' : '#EEEEEE';
            }
            return currentCollor;
        },
    },
    watch: {
        showArrowIcon: {
            handler() {
                if (this.canShowChildren) {
                    this.onClickToggleChildren();
                }
            },
            deep: true,
        },
    },
    methods: {
        onClickToggleEditable() {
            this.isVisible = !this.isVisible;
            this.$emit('change', this.isVisible);
        },
        onClickToggleChildren() {
            this.canShowChildren = !this.canShowChildren;
        },
        onClickChangeState() {
            this.$emit('state-changed', !this.visible);
        },
        isClickDisabled() {
            return !this.showArrowIcon && this.isWorkOrderTemplate;
        },
        canShow() {
            return this.isVisible || this.isWorkOrderTemplate;
        },
    },
};
</script>
<style scoped>
  .extra-padding {
    padding-left: 48px;
  }
</style>
